import React, { useState, useEffect } from 'react';
import { Box, TextField, Card, CardContent, Typography, List, ListItem, ListItemText, CircularProgress, Divider } from '@mui/material';
import api from '../../utils/api';
import tokenManager from '../../utils/tokenManager';

const GlobalSearch = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState({ users: [], teams: [] });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query.length < 2) {
            setResults({ users: [], teams: [] });
            return;
        }

        const delayDebounceFn = setTimeout(async () => {
            setLoading(true);
            try {
                const url = process.env.REACT_APP_API_URL || "http://localhost:3001/api"; // Fallback URL for testing
                // Workaround da useDataFetch ohne URL state changes tricky sein kann für typeahead
                const res = await api.get(`${url}/search?q=${query}`, {
                    headers: { 'Authorization': `Bearer ${tokenManager.getToken()}` }
                });
                if (res.data?.success) {
                    setResults({ users: res.data.users, teams: res.data.teams });
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }, 300); // 300ms Debounce

        return () => clearTimeout(delayDebounceFn);
    }, [query]);

    return (
        <Box sx={{ p: { xs: 2, md: 5 }, maxWidth: 800, mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>Globale Suche</Typography>
            <TextField
                fullWidth
                placeholder="Nutzer oder Team suchen..."
                variant="outlined"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                sx={{ mb: 3 }}
            />

            {loading && <CircularProgress />}

            {!loading && query.length >= 2 && (
                <Card>
                    <CardContent>
                        <Typography variant="h6" color="primary">Teams</Typography>
                        <Divider sx={{ mb: 1 }} />
                        {results.teams.length > 0 ? (
                            <List>
                                {results.teams.map(t => (
                                    <ListItem key={t.id} button component="a" href={`/teams`}>
                                        <ListItemText primary={t.team_name} />
                                    </ListItem>
                                ))}
                            </List>
                        ) : (
                            <Typography variant="body2" sx={{ mb: 2 }}>Keine Teams gefunden</Typography>
                        )}

                        <Typography variant="h6" color="primary" sx={{ mt: 3 }}>Nutzer</Typography>
                        <Divider sx={{ mb: 1 }} />
                        {results.users.length > 0 ? (
                            <List>
                                {results.users.map(u => (
                                    <ListItem key={u.id} button component="a" href={`/profil/${u.id}`}>
                                        <ListItemText primary={`${u.first_name} ${u.last_name}`} secondary={u.role.toUpperCase()} />
                                    </ListItem>
                                ))}
                            </List>
                        ) : (
                            <Typography variant="body2">Keine Nutzer gefunden</Typography>
                        )}
                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default GlobalSearch;
